<template>
  <el-config-provider :locale="language">
    <sc-provider>
      <router-view />
    </sc-provider>
  </el-config-provider>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useLang } from '@/lang/hooks/use-lang';

export default defineComponent({
  setup() {
    const { language } = useLang();

    return {
      language,
    };
  },
});
</script>
<style lang="scss">
#app {
  height: 100%;
}
</style>
